import { Outlet, useLocation } from 'react-router-dom'
import ToolBarRightContainer from 'components/toolbar/ToolBarRightContainer';
import ToolBarLeftContainer from 'components/toolbar/ToolBarLeftContainer';
import SideBarNav from 'components/sidebar/SideBarNav';
import { useState } from 'react';
import Paginator from 'components/others/Paginator';
import { useGlobal } from 'context/GlobalContext';
import LocaleFilter from 'components/footer/LocaleFilter';
import LeadSelected from 'components/Leads/LeadSelected';
import ObjectSelected from 'components/ObjectsList/ObjectSelected';
import ProductsSelect from 'components/Products/ProductsSelect';
import ProductSetsSelect from 'components/ProductsSets/ProductSetsSelect';
import ServicesSelect from 'components/Services/ServicesSelect';
import UserSelected from 'components/Users/UserSelected';
import ClientSelected from 'components/Clients/ClientSelected';


const MainLayout = () => {
 
    const [ pcSideBarShow, setPcSideBarShow ] = useState(true);
    const [ mobSideBarShow, setMobSideBarShow ] = useState(false);
    const { g } = useGlobal();
    const location = useLocation();

  
    return ( 
    <div> 
        <SideBarNav   
            pcSideBarShow={pcSideBarShow}
            setPcSideBarShow={setPcSideBarShow}
            mobSideBarShow={mobSideBarShow}
            setMobSideBarShow={setMobSideBarShow}/>
        <div className="pc-header">
            <div className="header-wrapper ps-1">
                <div className="me-auto pc-mob-drp">
                    <ToolBarLeftContainer
                        pcSideBarShow={pcSideBarShow}
                        setPcSideBarShow={setPcSideBarShow}
                        mobSideBarShow={mobSideBarShow}
                        setMobSideBarShow={setMobSideBarShow}/>
                </div>
                <div className="ms-auto">
                    <ToolBarRightContainer/>
                    </div>
            </div>
        </div>   
        <div className="pc-container"
            style={{marginBottom:'130px'}}>
            <div className='pc-content pt-0'>
                <Outlet />      
            </div>
        </div>
  
        <footer className="pc-footer d-flex">
            {(g.localeFilterActive) && (
                <div>
                <LocaleFilter/>
                </div>
                )}
             
            <div className="footer-wrapper container-fluid">
                
                {
                    // Пагінатор
                    ((g.paginator?.[location.pathname]) && (!g.footerComponent)) && (
                        <Paginator paginator={g.paginator?.[location.pathname]}/>) 
                }

                {
                    // Компонент футера
                    (g.footerComponent && (g.footerComponent))
                }
 
            </div>
        </footer>

        <LeadSelected preload />
        <ObjectSelected preload />
        <ProductsSelect preload />
        <ProductSetsSelect preload />
        <ServicesSelect preload />
        <UserSelected preload />
        <ClientSelected preload />
    </div>
    )
}

export default MainLayout;
